module.exports = __webpack_public_path__ + "img/qwello-card-ic.48ec8e88.svg";